import { getPrevWeek } from "src-lib/util/date";
import "../src-routes";

const LS_PREFETCHED_URI = "prefetched-uri";
const MAX_RETRIES = 2;
const visited: Array<string> = [];

setTimeout(() => {
    if (!window.fetch) return;
    const lastWeek = getPrevWeek(1);

    let prefetchedURIs = getPrefetchedURIs();

    let sitelinks = (window as any).SITE_LINKS as Array<string>;
    if (sitelinks) {
        sitelinks.forEach((uri) => {
            let lastAccessed = prefetchedURIs.get(uri);
            if (!lastAccessed || new Date(lastAccessed) < lastWeek) {
                preloadPage(uri).then((res) => {
                    prefetchedURIs = getPrefetchedURIs(); // get latest
                    prefetchedURIs.set(uri, new Date());
                    savePrefetchedURIs(prefetchedURIs);
                });
            }
        });
    }
}, 2000);

function preloadPage(url: string, attempt = 1): Promise<void> {
    if (visited.indexOf(url) !== -1) return Promise.resolve();

    visited.push(url);

    return preload(url).then((htmlText) => {
        let newHTML = document.createElement("html");
        newHTML.innerHTML = htmlText;

        preloadCSS();
        preloadJS();

        function preloadCSS() {
            let head = newHTML.querySelector("head") as HTMLHeadElement;
            let links = head.querySelectorAll("link");

            for (let i = 0; i < links.length; i++) {
                let rel = links.item(i).getAttribute("rel"),
                    type = links.item(i).getAttribute("type");
                if (rel !== "stylesheet" || type !== "text/css") continue;
                let href = links.item(i).getAttribute("href");
                if (!href) continue;
                if (visited.indexOf(url) !== -1) continue;
                visited.push(href);
                preload(href);
            }
        }

        function preloadJS() {
            let body = newHTML.querySelector("body") as HTMLBodyElement;
            let scripts = body.querySelectorAll("script");

            for (let i = 0; i < scripts.length; i++) {
                let src = scripts.item(i).getAttribute("src"),
                    type = scripts.item(i).getAttribute("type");
                if (!src || type !== "text/javascript") continue;
                if (visited.indexOf(url) !== -1) continue;
                visited.push(src);

                preload(src);
            }
        }
    });
}

function savePrefetchedURIs(prefetchedURIs: Map<string, Date | string>) {
    localStorage.setItem(LS_PREFETCHED_URI, JSON.stringify([...prefetchedURIs]));
}

function getPrefetchedURIs(): Map<string, string | Date> {
    let prefetchedURI;
    let localStorageStr = localStorage.getItem(LS_PREFETCHED_URI);
    if (localStorageStr === null) {
        localStorage.setItem(LS_PREFETCHED_URI, JSON.stringify([]));
        prefetchedURI = new Map();
    } else {
        prefetchedURI = new Map(JSON.parse(localStorageStr));
    }
    return prefetchedURI;
}

function preload(url: string, attempt = 1): Promise<string> {
    try {
        return fetch(url).then((res) => res.text());
    } catch (e) {
        console.warn("Failed to fetch " + url);
        if (attempt < MAX_RETRIES) {
            return preload(url, attempt + 1);
        } else {
            throw new Error("Couldn't preload " + url);
        }
    }
}
